import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import { Relation } from './relations.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/relations');

export const getRelations = actionCreator.async<{}, Relation[]>('GET_RELATIONS');
export const createRelation = actionCreator.async<{ data: Partial<Relation>; formName: FormName }, Relation>(
  'CREATE_RELATION',
);
export const updateRelation = actionCreator.async<{ data: Partial<Relation>; formName: FormName }, Relation>(
  'UPDATE_RELATION',
);
export const deleteRelation = actionCreator.async<{ id: string; formName: FormName }, string>('DELETE_RELATION');
